var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isEmpty, union } from "ramda";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Dialog, Icon, Table } from "@material-ui/core";
import { WebSocketMessage } from "../../serverConnection";
var enterpriseMatch = function (userEnterprises, watcherEnterprises) {
    return union(userEnterprises, watcherEnterprises).length > 0;
};
var UserTableAgent = /** @class */ (function (_super) {
    __extends(UserTableAgent, _super);
    function UserTableAgent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            nameFilter: "",
            cityFilter: "",
            open: -1,
        };
        _this.onDeleteClick = function (id) {
            _this.setState({ open: -1 });
            _this.props.send(WebSocketMessage("users", "delete", { id: id }));
        };
        return _this;
    }
    UserTableAgent.prototype.render = function () {
        var _this = this;
        var id = this.props.currentUser.id;
        var users = this.props.users
            .filter(function (user) {
            var _a, _b, _c, _d;
            if (!isEmpty(_this.state.cityFilter) && !user.city.toLocaleLowerCase().includes(_this.state.cityFilter)) {
                return false;
            }
            var name = ((_a = user.firstName) !== null && _a !== void 0 ? _a : "") + ((_b = user.lastName) !== null && _b !== void 0 ? _b : "");
            if (!isEmpty(_this.state.nameFilter) && !name.toLocaleLowerCase().includes(_this.state.nameFilter)) {
                return false;
            }
            if (_this.props.currentUser.role === "su") {
                return true;
            }
            switch (user.role) {
                case "customer":
                    return user.agent === id;
                case "agent":
                case "admin":
                    return (enterpriseMatch((_c = user.enterprises) !== null && _c !== void 0 ? _c : [], _this.props.currentUser.enterprises) &&
                        _this.props.currentUser.role === "admin");
                default:
                    break;
            }
            if (enterpriseMatch((_d = user.enterprises) !== null && _d !== void 0 ? _d : [], _this.props.currentUser.enterprises)) {
                return false;
            }
            return true;
        })
            .sort(function (a, b) {
            return a.company.localeCompare(b.company);
        })
            .map(function (user, i) {
            var _a;
            return (React.createElement("tr", { key: user.id },
                React.createElement("td", null,
                    React.createElement("strong", null, user.company)),
                React.createElement("td", null,
                    user.firstName,
                    " ",
                    user.lastName),
                React.createElement("td", null, user.email),
                React.createElement("td", null, user.address),
                React.createElement("td", null, user.city),
                user.isHost ? React.createElement("td", { className: "green-text" }, "Host") : React.createElement("td", null, " - "),
                React.createElement("td", null, (_a = user.industry) !== null && _a !== void 0 ? _a : "---"),
                React.createElement("td", null,
                    React.createElement(Link, { to: "/users/" + user.id },
                        React.createElement(Icon, null, "edit"))),
                React.createElement("td", null,
                    React.createElement(Button, null,
                        React.createElement(Icon, { onClick: function () { return _this.setState({ open: i }); }, style: { color: "red" } }, "clear")),
                    React.createElement(Dialog, { open: _this.state.open === i, onClose: function () { return _this.setState({ open: -1 }); } },
                        React.createElement("div", { style: { margin: 8 } },
                            React.createElement("p", null,
                                "Are you sure you want to delete ",
                                user.email,
                                "?"),
                            React.createElement("br", null),
                            React.createElement(Button, { className: "red darken-2", onClick: function () { return _this.onDeleteClick(user.id); } },
                                React.createElement(Icon, null, "delete"),
                                " Delete"),
                            "\u00A0",
                            React.createElement(Button, { onClick: function () { return _this.setState({ open: -1 }); } }, "Cancel"))))));
        });
        return (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col s12 m12 l12" },
                React.createElement("h5", null, "Customers"),
                React.createElement("br", null),
                React.createElement("div", { className: "card-panel" },
                    React.createElement(Table, null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Company"),
                                React.createElement("th", null, "Name"),
                                React.createElement("th", null, "Email"),
                                React.createElement("th", null, "Address"),
                                React.createElement("th", null, "City"),
                                React.createElement("th", null, "Host"),
                                React.createElement("th", null, "Industry"),
                                React.createElement("th", null),
                                React.createElement("th", null))),
                        React.createElement("tbody", null,
                            React.createElement("tr", { key: "filters" },
                                React.createElement("td", null,
                                    React.createElement("em", null, "Filters")),
                                React.createElement("td", null,
                                    React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.nameFilter, onChange: function (e) {
                                            return _this.setState({ nameFilter: e.target.value.toLocaleLowerCase() });
                                        } })),
                                React.createElement("td", null),
                                React.createElement("td", null),
                                React.createElement("td", null,
                                    React.createElement("input", { style: { height: "1rem", minHeight: "1rem", margin: 0 }, value: this.state.cityFilter, onChange: function (e) {
                                            return _this.setState({ cityFilter: e.target.value.toLocaleLowerCase() });
                                        } })),
                                React.createElement("td", null),
                                React.createElement("td", null),
                                React.createElement("td", null),
                                React.createElement("td", null)),
                            users))))));
    };
    return UserTableAgent;
}(Component));
export default UserTableAgent;



//////////////////
// WEBPACK FOOTER
// ./src/components/users/UserTableAgent.tsx
// module id = 1222
// module chunks = 0